module.exports = __webpack_public_path__ + "assets/img/00054.fe53968b.png";